"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  height: auto;\n  display: block;\n"], ["\n  width: 100%;\n  height: auto;\n  display: block;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _buoyTheme = require("buoy-theme");

var _reactLazyload = require("react-lazyload");

var _reactLazyload2 = _interopRequireDefault(_reactLazyload);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Image = _styledComponents2.default.img.withConfig({
  displayName: "src__Image",
  componentId: "zsp621-0"
})(_templateObject);

var LazyLoadImage = function LazyLoadImage(_ref) {
  var imgAbsolutePath = _ref.imgAbsolutePath,
      imgAlt = _ref.imgAlt,
      maxWidth = _ref.maxWidth,
      widthHeightRatio = _ref.widthHeightRatio,
      className = _ref.className;

  if (!imgAbsolutePath || !imgAlt || !maxWidth || !widthHeightRatio) return null;

  var srcSet = null;
  var triggeredWidths = [];

  if (maxWidth > _buoyTheme.breakpoints.xs && !imgAbsolutePath.endsWith("svg") && !imgAbsolutePath.endsWith("gif")) {
    triggeredWidths.push(_buoyTheme.breakpoints.xs);

    if (maxWidth >= _buoyTheme.breakpoints.sm) {
      triggeredWidths.push(_buoyTheme.breakpoints.sm);
    }

    if (maxWidth >= _buoyTheme.breakpoints.md) {
      triggeredWidths.push(_buoyTheme.breakpoints.md);
    }

    if (maxWidth >= _buoyTheme.breakpoints.lg) {
      triggeredWidths.push(_buoyTheme.breakpoints.lg);
    }

    triggeredWidths = triggeredWidths.map(function (width) {
      return imgAbsolutePath + "?auto=format&fit=crop,edges&w=" + width * 2 + "&h=" + Math.round(width / widthHeightRatio) * 2 + " " + width * 2 + "w";
    });
  }

  srcSet = triggeredWidths.join(", ");

  return _react2.default.createElement(
    _reactLazyload2.default,
    {
      offset: 400,
      height: Math.round(_buoyTheme.breakpoints.xs / widthHeightRatio),
      once: true,
      throttle: 500
    },
    _react2.default.createElement(
      "div",
      { className: className },
      _react2.default.createElement(Image, {
        src: imgAbsolutePath + "?auto=format&w=" + maxWidth * 2 + "&h=" + Math.round(maxWidth / widthHeightRatio) * 2 + "&fit=crop,edges",
        alt: imgAlt,
        srcSet: srcSet
      })
    )
  );
};

LazyLoadImage.defaultProps = {
  maxWidth: 1320,
  widthHeightRatio: 1.778
};

LazyLoadImage.propTypes = {
  imgAbsolutePath: _propTypes2.default.string.isRequired,
  imgAlt: _propTypes2.default.string.isRequired,
  maxWidth: _propTypes2.default.number.isRequired,
  widthHeightRatio: _propTypes2.default.number.isRequired
};

exports.default = LazyLoadImage;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-image/dist/index.js
// module id = 427
// module chunks = 168707334958949